import { Ng2StateDeclaration } from '@uirouter/angular';
import { DashboardPageComponent } from './feature/dashboard-page/dashboard-page.component';

export const DASHBOARD_STATES: Ng2StateDeclaration[] = [
  {
    name: 'app.dashboardNew',
    url: '/dashboard-new',
    component: DashboardPageComponent,
    data: { requiresAuth: true }
  }
];
